import React from 'react';
import { CalendarDaysIcon, ListBulletIcon } from '@heroicons/react/24/outline';

/**
 * ViewToggle - Toggle between Calendar and List view
 *
 * Two variants:
 * - Desktop (variant="icon"): Compact icon-only buttons in header
 * - Mobile/Tablet (variant="text"): Full text labels, centered, pill-shaped
 */
const ViewToggle = ({
  displayMode,
  setDisplayMode,
  variant = 'icon', // 'icon' | 'text'
  className = ''
}) => {
  const modes = [
    { key: 'calendar', icon: CalendarDaysIcon, label: 'Calendar' },
    { key: 'list', icon: ListBulletIcon, label: 'List' }
  ];

  // Desktop: Icon-only compact toggle
  if (variant === 'icon') {
    return (
      <div className={`flex items-center gap-0.5 bg-gray-200 rounded-lg p-0.5 ${className}`}>
        {modes.map((mode) => {
          const Icon = mode.icon;
          const isActive = displayMode === mode.key;

          return (
            <button
              key={mode.key}
              onClick={() => setDisplayMode(mode.key)}
              className={`p-1.5 sm:p-2 rounded-md transition-all duration-200 ${
                isActive
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
              title={mode.label}
              aria-label={mode.label}
            >
              <Icon className="h-4 w-4 sm:h-5 sm:w-5" />
            </button>
          );
        })}
      </div>
    );
  }

  // Mobile/Tablet: Text labels, pill-shaped, no heavy background
  return (
    <div className={`flex items-center gap-1 bg-gray-100 rounded-full p-1 ${className}`}>
      {modes.map((mode) => {
        const Icon = mode.icon;
        const isActive = displayMode === mode.key;

        return (
          <button
            key={mode.key}
            onClick={() => setDisplayMode(mode.key)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              isActive
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            aria-label={mode.label}
          >
            <Icon className="h-4 w-4" />
            <span>{mode.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ViewToggle;
